<template>
  <div>
    <Table
        :key="initTable"
        ref="TableComponent"
        :body="{}"
        :title="'investment_profiles'"
        :fields="fields"
        :url="url"
        :show-search="true"
        :show-dropdown="false"
        :show-filters="false"
    >
      <template #cell(id)="data">
          <router-link :to="'/admin-investment-profile/' + data.item.id" style="width:55px;" class="badge badge-light-primary"> {{ data.item.id }}</router-link>
      </template>

      <template #cell(name)="data" >
         {{ data.item.user.name }}
      </template>

      <template #cell(user_id)="data">
        <span v-if="data.item.user_id">U-{{ data.item.user_id }}</span>
        <span v-else>-</span>
      </template>

      <template #cell(company_id)="data">
        <span v-if="data.item.user_id">C-{{ data.item.user.company.id }}</span>
        <span v-else>-</span>
      </template>

      <template #cell(is_active)="data">
        <span v-if="data.item.is_active" class="text-success">
          {{ $t("active") }}
        </span>
        <span v-else class="text-danger">
          {{ $t("inactive") }}
        </span>
      </template>

      <template #cell(activated_at)="data">
        {{ data.item.activated_at | formatDate }}
      </template>

      <template #cell(deactivated_at)="data">
        <span v-if="!data.item.is_active && data.item.deactivated_at">
          {{ data.item.deactivated_at | formatDate }}
        </span>
        <span v-else>
          -
        </span>
      </template>

      <template #cell(actions)="data">
        <b-button
            size="sm"
            v-b-tooltip.hover
            class="button-space"
            variant="outline-success"
            :title="$t('login_as_client')"
            @click="loginAsClientFromAdmin(data.item)"
            v-if="adminType(['super_admin', 'admin_type_a']) && data.item.is_active"
        >
          <feather-icon icon="UserIcon" />
        </b-button>
        <b-link :to="'/admin-investment-profile/' + data.item.id">
          <b-button
              v-b-tooltip.hover
              variant="outline-primary"
              size="sm"
              class="button-space ml-1"
              :title="$t('edit')"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
        </b-link>
      </template>
    </Table>
  </div>
</template>

<script>
import Table from '@/components/Common/Table2.vue'
import {BButton, BLink} from "bootstrap-vue";

export default {
  name: 'AdminInvestmentProfiles',
  components: {BButton, BLink, Table },
  data() {
    return {
      url: '/admin-investment-profile',
      initTable: 'init',
      fields: [
        { label: 'id', key: 'id', sortable: false, customSlot: true },
        { label: 'username', key: 'name', sortable: false, customSlot: true },
        { label: 'user_id', key: 'user_id', sortable: true },
        { label: 'company_id', key: 'company_id', sortable: false, customSlot: true },
        { label: 'status', key: 'is_active', sortable: true, customSlot: true },
        { label: 'activated_at', key: 'activated_at', sortable: true, customSlot: true },
        { label: 'deactivated_at', key: 'deactivated_at', sortable: true, customSlot: true },
        { label: 'actions', key: 'actions', sortable: false, customSlot: false },
      ],
    }
  },
  methods: {
    loginAsClientFromAdmin(item) {
      this.isLoading = true
      this.items = []
      this.$http
      .post('/loginFromAdmin', {
        email: item.user.email,
      })
      .then(response => {
        if (response.data.status === 200) {
          const stagingEndpoint = window.location.origin.includes('staging') || window.location.origin.includes('localhost') ? '-staging' : ''
          const token = response.data.value.token;
          const redirectUrl = `https://terminal${stagingEndpoint}.aequitex.com/loginFromAdmin/${token}?isAdminLogin=true`;

          // for checking in localhost
          // const redirectUrl = `http://localhost:8082/loginFromAdmin/${token}?isAdminLogin=true`;

          window.open(redirectUrl, '_blank');
        }
        this.isLoading = false
      })
      .catch(error => {
        this.isLoading = false
      })
    },
  }
}
</script>

